import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import resolvable from '@mailobj-browser/front/js/utils/resolvable.js'
import plugins from '../plugins/plugins.js'

export default async (filepath) => {
  const { window } = defaults
  const { FileReader, Blob } = window
  const { fs } = plugins
  const [promise, { resolve, reject }] = resolvable()

  fs(filepath, r => r.file(file => {
    const reader = new FileReader()
    reader.onloadend = e => {
      const blob = new Blob([reader.result], { type : file.type })
      resolve({ file, blob })
    }
    reader.readAsArrayBuffer(file)
  }), reject)

  return promise
}
